import React, { useEffect } from 'react'
import { MdLocationPin } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { MdOutlineVerified } from "react-icons/md";
import { getPromoteUsers } from '../Redux/Slices/AgentSlice';

function PremiumUsers() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const token = localStorage.getItem("token")
    const userId = localStorage.getItem("userId");

    const PromotedUsers = useSelector((state) => state.Agent.promoteUsers);

    console.log("PromotedUsers", PromotedUsers)
    const checkAuthentication = () => {
    if (!token) {
      navigate('/Login');
    } else {
      navigate(`/HireAgent`);
    }
  };

    
    useEffect(() => {
        dispatch(getPromoteUsers());
    }, []);


    return (
        <>
        {PromotedUsers.length == 0 ?
          null
          : 
        <section className="vendor-main container ">
            <div>
                <h5 className="fw-bold mb-5 mt-5">Premium Users</h5>
            </div>
            <div className="row row-cols-sm-2 row-cols-md-3 row-cols-lg-3">
                {PromotedUsers.map((data) => {
                    return (
                        <div className="mb-6">
                            <div className="card shadow-hover-xs-4 agent-3 position-relative border-0" style={{ background: "linear-gradient(135deg, #f5f7fa, #c3cfe2)" }}>
                                <span
                                    className="badge badge-success position-absolute"
                                    style={{ top: "10px", left: "10px", zIndex: 1 }}
                                >
                                    <MdOutlineVerified />   Premium {data.userData?.userrole}
                                </span>
                                {/* Card Image */}
                                <div className="card-header text-center bg-transparent text-center p-0">
                                    <a className="d-inline-block mb-2 w-120px h-120 position-relative">
                                        <img src= { data.userData.image || "https://www.pngitem.com/pimgs/m/661-6619328_default-avatar-png-blank-person-transparent-png.png"}
                                        alt="Max Kordek" className="w-100 h-auto rounded-circle" /> {/* Make image circular */}
                                    </a>
                                </div>

                                {/* Card Body */}
                                <div className="card-body text-center p-3">
                                    {/* Name and Location in One Line */}
                                    <h6 className="card-title mb-1">
                                        <a className="text-dark font-weight-500 hover-primary text-decoration-none">
                                            {data.userData?.firstname}{" "} {data.userData?.lastname}
                                        </a>
                                        {" "}
                                        <span className="text-muted">
                                            <MdLocationPin color='red' />
                                            {data.userData?.city ? `${data.userData.city.slice(0, 20)}${data.userData.city.length > 20 ? '...' : ''}` : 'Location not available'}
                                        </span>
                                    </h6>

                                    {/* View Details Button */}
                                    <button
                                        type="button"
                                        onClick={()=>checkAuthentication()}
                                        className="btn btn-primary btn-sm mt-3 w-100"
                                        style={{ borderRadius: "20px" }}
                                    >
                                        Hire me
                                    </button>
                                </div>
                            </div>
                        </div>
                    )
                })}

            </div>
        </section>
}
</>
    )
}

export default PremiumUsers